import { Wrapper } from "@/page/devProfileSetting/styled";
import shortid from "shortid";
import * as React from "react";
import {
  ButtonContainer,
  Content,
  ContentContainer,
  LeftButtons,
  RightButtons,
  Title,
  Button as ButtonComponent,
} from "../styled";

export interface IProps {
  title?: React.ReactNode;
  titleLocale?: Moim.Localization.ILocaleElement[];
  content?: React.ReactNode;
  contentLocale?: Moim.Localization.ILocaleElement[];
  leftButtons?: IButton[];
  rightButtons?: IButton[];
}

interface IButton {
  text: React.ReactNode;
  textLocale?: Moim.Localization.ILocaleElement[];
  disabled?: boolean;
  textColor?: string;
  onClick: () => void;
}

function AlertModalLayout(props: IProps) {
  const { leftButtons, rightButtons } = props;
  const localizedTitle = useLocaleElement(props, "title");
  const localizedContent = useLocaleElement(props, "content");
  return (
    <Wrapper>
      <ContentContainer data-scroll-lock-scrollable>
        {localizedTitle && <Title>{localizedTitle}</Title>}
        {localizedContent && <Content>{localizedContent}</Content>}
      </ContentContainer>

      <ButtonContainer>
        {leftButtons && <LeftButtons>{renderButtons(leftButtons)}</LeftButtons>}

        {rightButtons && (
          <RightButtons>{renderButtons(rightButtons)}</RightButtons>
        )}
      </ButtonContainer>
    </Wrapper>
  );
}

const Button: React.FC<{ button: IButton }> = ({ button }) => {
  const text = useLocaleElement(button, "text");
  return (
    <ButtonComponent
      onClick={button.onClick}
      key={shortid()}
      disabled={button.disabled}
      textColor={button.textColor}
    >
      {text}
    </ButtonComponent>
  );
};

function renderButtons(buttons: IButton[]) {
  return buttons.map((button, idx) => <Button key={idx} button={button} />);
}

function useLocaleElement(entity: Record<string, any>, key: string) {
  // const locale = useCurrentUserLocale();

  // return getLocaleElementShort(entity, key, locale);
  return entity[key];
}

export default AlertModalLayout;
